<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="addOrEdit" :loading="btnLoading" v-if="!disable">会签</el-button>
      <el-button @click="close">关闭</el-button>
      <span style="margin-left: 50px;" >项目名称：{{project.projectcode}}-{{project.projectname}}</span>
      <span v-if="disable" style="color: red;margin-left:100px;">评分已会签</span>
    </div>
    <el-table :data="pgsList"  style="" height="400" border @cell-click="cellClick">
      <el-table-column type="index" label="行号" width="50"></el-table-column>
      <el-table-column label="评审人" prop="expertname" width="100"></el-table-column>
      <el-table-column label="供应商" prop="pgsucomname" width="100"></el-table-column>
      <el-table-column label="价格" prop="pgsuamt" width="100"></el-table-column>
      <div v-for="(pg,index) in pgList" >
        <el-table-column :key="index" :label="pg.pgname" width="100" :index="index">
          <template slot-scope="scope">
            {{scope.row.pgsuas[index].pgsuas}}
          </template>
        </el-table-column>
        <el-table-column label="百分比" width="100">
          <template slot-scope="scope">
            {{scope.row.pgsuas[index].pgsuratio}}
          </template>
        </el-table-column>
      </div>
      <el-table-column label="总分" prop="pgsuts" width="100"></el-table-column>
    </el-table>
    <div>
      <span>已会签评审人：</span><span v-for="(item,index) in pgsignList" style="margin-left: 10px">{{item.username}}</span>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: "pgsignForm",
    data () {
      return {
        project: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: false,
        btnLoading: false,
        pgsList: [],
        pgList: [],
        pgsItemList: [],
        pgsignList: [],
        pgs: {},
        pgIndex: -1
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getPgList()
      this.getPgsList()
      this.getPgsignList()
    },
    watch: {
    },
    filters: {
      newDateTime (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd HH:mm:ss')
      },
    },
    components: {},
    computed: {
    },
    methods: {
      async init() {
        this.project = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = false
        this.btnLoading = false
        this.pgsList = []
        this.pgList = []
        this.pgsItemList = []
        this.pgs = {}
        this.pgIndex = -1
      },

      async changeStatus() {
        let status = this.project.pgsignstatus
        if (status === '2') {
          this.disable = true
        } else {
          this.disable = false
        }
      },
      async cellClick(row, column, cell, event) {

      },
      async getPgList() {
        this.pgList = await request({
          method: 'get',
          url: '/xmgl/project/getPgList',
          params: {projectid: this.project.projectid}
        })
        console.log(this.pgList)
      },
      async getPgsList () {
        this.pgsList = await request({
          method: 'get',
          url: '/xmgl/pgs/getPgsuListByProjectId',
          params: {projectid: this.project.projectid}
        })
        console.log(this.pgsList)
        await this.changeStatus()
      },
      async getPgsignList () {
        this.pgsignList = await request({
          method: 'get',
          url: '/xmgl/pgs/getPgsignListByProjectId',
          params: {projectid: this.project.projectid}
        })
        console.log(this.pgsignList)
      },
      async addOrEdit () {
        let model = {
          pexpertid: this.project.pexpertid,
          projectid: this.project.projectid
        }

        let data = await request({
          url: '/xmgl/pgs/savePgsign',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.disable = true
          await this.getPgsignList()
          this.$message.success('项目会签成功')
        } else {
          this.$message.error('项目会签失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pgsignIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
